import { z } from 'zod';

import { makeFeatureFlagPayloadValidator } from './utils';

export const chunkedBatchTranscriptionDuration =
  makeFeatureFlagPayloadValidator({
    defaultEnabled: false,
    schema: z.object({
      chunkDurationMinutes: z.number(),
    }),
    defaultValue: {
      chunkDurationMinutes: 5,
    },
  });
